import type { ReactNode } from 'react';

type SettingsSectionProps = {
  title: string;
  description?: ReactNode;
  /** Controle à direita do título (ex.: o switch do gateway). */
  aside?: ReactNode;
  children?: ReactNode;
};

/** Bloco de conteúdo das abas de formas de pagamento. */
export function SettingsSection({
  title,
  description,
  aside,
  children,
}: SettingsSectionProps) {
  return (
    <section className='flex flex-col gap-4 rounded-xl border border-alba-gray-200 bg-white p-4'>
      <div className='flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between'>
        <div className='min-w-0'>
          <h3 className='text-base font-semibold text-alba-black-500'>
            {title}
          </h3>
          {description && (
            <p className='mt-1 text-sm text-alba-gray-600'>{description}</p>
          )}
        </div>
        {aside && <div className='shrink-0'>{aside}</div>}
      </div>
      {children}
    </section>
  );
}
